import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    defaultNewFixedAssetRecord,
    setNewFixedAssetRecord, setNewFixedAssetRecordAutomatedData
} from "../../../../_reducers/DataPanel/FixedAssets/fixedAssetsSlice";
import {Button, Col, Modal, Row} from "react-bootstrap";
import axios from "axios";
import {fetchAdvancedTypes, fetchFixedAssetsSettings} from "../../../../_apis/api";
import {isEmpty} from "../../../../_helpers/commonFunctions";
import Dropdown from "../../../primer/Dropdown";
import DateBox from "../../../primer/DateBox";
import moment from "moment/moment";
import Input from "../../../common/Input";
import EditableTable from "../../../primer/Editable-Table";
import TextArea from "../../../common/TextArea";
import {setSaveNewFixedAssetRecord} from "../../../../_reducers/activitySlice";
import useInstallationOptions from "../../../../hooks/useInstallationOptions";
import {toast} from "react-toastify";
import {correctFixedAssetRecordRow, getAcquisitionCost, getDevaluation} from "./constants";

const NewFixedAssetRecord = ({fromSale = false, defaultDate = null}) => {
    const dispatch = useDispatch();
    const newFixedAssetRecord = useSelector((state) => state.FIXED_ASSETS.newFixedAssetRecord);
    const saveNewFixedAssetRecord = useSelector((state) => state.ACTIVITY.saveNewFixedAssetRecord);
    const advancedTypes = useSelector((state) => state.SETTINGS.settings.advancedTypes);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const fixedAssetsSettings = useSelector((state) => state.FIXED_ASSETS.fixedAssetsSettings);
    const newFixedAssetRecordAutomatedData = useSelector((state) => state.FIXED_ASSETS.newFixedAssetRecordAutomatedData);

    const installationOptions = useInstallationOptions();
    const [fixedAssetsList, setFixedAssetsList] = useState([]);
    const [loadingAll, setLoadingAll] = useState(false);

    const documentTypesOptions = advancedTypes.length > 0 ?
        advancedTypes.filter((el) => el.section === "Fixed Asset Records").map((o) => {
            return {
                value: o._id,
                label: o.name,
            }
        })
        : [];

    const preNumberGreekOptions = (advancedTypes.length > 0 && newFixedAssetRecord.installation && newFixedAssetRecord.documentType) ?
        advancedTypes.find((el) => el._id === newFixedAssetRecord.documentType)?.documentNumbering?.map((docNum) => {
            if (docNum.installationMasterId === newFixedAssetRecord.installation) {
                return {
                    value: docNum.preNumber,
                    label: docNum.preNumber === "noprefix" ? "Κενή" : docNum.preNumber,
                    number: docNum.number,
                }
            }
            return null;
        }).filter(Boolean)
        : [];

    const calculationBy = newFixedAssetRecord?.documentType ?
        (advancedTypes.find((el) => el._id === newFixedAssetRecord.documentType)?.depreciationCalculation || "daily")
        :
        "daily";

    const fixedAssetsCategoryOptions = [
        {value: "", label: "Όλες"},
        ...fixedAssetsSettings.categories.map((o) => {
            return {
                value: o._id,
                label: o.name,
            }
        }
    )]

    const [toChangeDocumentType, setToChangeDocumentType] = useState("");
    const [fillAssetCategory, setFillAssetCategory] = useState("");

    const [incrKey, setIncrKey] = useState(0);

    useEffect(() => {
        setIncrKey(incrKey + 1);
    }, [newFixedAssetRecord.fixedAssets, fixedAssetsList])

    const loadFixedAssetsListData = (keyword, setData) => {
        const reqData = {
            company: company.id,
            documentId: newFixedAssetRecord.documentType || "",
            installation: newFixedAssetRecord.installation,
        }
        if (keyword) reqData.keyword = keyword;
        axios.get(`${process.env.REACT_APP_API_URL2}/fixedassets/list-fixed-assets`, {
            headers: {'Content-Type': 'application/json'},
            params: reqData,
        }).then((res) => {
            if (res.data.status === "200") {
                if (res.data.data.length > 0) {
                    res.data.data.forEach((asset) => {
                        asset.finalAcquisitionCost = getAcquisitionCost(asset);
                    })
                }
                setData(res.data.data);
            }
        }).catch((err) => {
            setData([]);
            console.log(err);
        })
    }

    const tableColumns  = [
        {
            name: "Αρ.",
            field: "no",
            editable: false,
            width: "5%",
        },
        {
            name: "Κωδικός Συστήματος / Χειροκίνητος Κωδικός",
            field: "mixedCode",
            editable: false,
            width: "15%",
        },
        {
            name: "Όνομα Παγίου",
            field: "name",
            editable: !fromSale,
            width: "35%",
            inputType: {
                config: {
                    onChangeSearchCell: (_, keyword, setData) => loadFixedAssetsListData(keyword, setData),
                    excludeColumns: [],
                    columns: [
                        {label: "Όνομα", name: "name"},
                        {label: "Κόστος Κτήσης", name: "finalAcquisitionCost"},
                        {label: "Αποσβεσμένο Ποσό", name: "accumulatedDepreciation"},
                    ],
                    data: fixedAssetsList,
                    deleteEnable: false,
                    searchTableEnable: false,
                    showTableOptionOnSelect: true,
                    placeholder: "Επιλέξτε πάγιο"
                },
                type: 'advanced-combobox',
            }
        },
        {
            name: "Κόστος Κτήσης",
            field: 'acquisitionCost',
            editable: true,
            disabled: true,
            width: "10%",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 10,
                    allowNegative: true,
                    notAllowed: true,
                }
            }
        },
        {
            name: "Αποσβεσμένο Ποσό",
            field: 'accumulatedDepreciation',
            editable: true,
            disabled: true,
            width: "10%",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 10,
                    allowNegative: true,
                    notAllowed: true,
                }
            }
        },
        {
            name: "Ποσό απόσβεσης",
            field: 'amount',
            editable: true,
            width: "10%",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 10,
                }
            }
        },
        {
            name: "Νέο υπόλοιπο",
            field: "balance",
            editable: true,
            disabled: true,
            width: "10%",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 10,
                    allowNegative: true,
                    notAllowed: true,
                }
            }
        },
    ];

    useEffect(() => {
        if (!fromSale) dispatch(fetchAdvancedTypes({company: company.id}));
        dispatch(fetchFixedAssetsSettings(company.id));
        if (
            defaultDate ||
            (
                String(company.year) !== String(moment().year())
                && (String(moment(newFixedAssetRecord.date).year()) !== company.year || String(moment(newFixedAssetRecord.dateTo).year()) !== company.year)
            )
        ) {
            const lastDate = defaultDate ? moment(defaultDate).hour(12).toDate() : moment(company.year, "YYYY").endOf("year").hour(12).toDate();
            dispatch(setNewFixedAssetRecord({
                ...newFixedAssetRecord,
                date: lastDate,
                dateTo: lastDate,
            }))
        }
    }, [])

    useEffect(() => {
        if (Object.keys(newFixedAssetRecordAutomatedData).length > 0) {
            let prepObj = {...defaultNewFixedAssetRecord};
            prepObj.date = defaultDate;
            prepObj.dateTo = defaultDate;
            const asset = newFixedAssetRecordAutomatedData.selectedAsset;
            const md = asset?.mydata;
            let prepAsset = {
                _id: asset._id,
                no: "1",
                name: asset.name,
                mixedCode: asset.systemCode + (asset.manualCode ? ` / ${asset.manualCode}` : ""),
                acquisitionCost: getAcquisitionCost(asset),
                accumulatedDepreciation: asset.accumulatedDepreciation,
                amount: getDevaluation(asset, moment(prepObj.dateTo).toDate(), "monthly").devaluationAfterBalance,
                classificationCategory: md ? md[0].category : "",
                classificationType: md ? md[0].type : "",
            }
            prepObj.fixedAssets = [correctFixedAssetRecordRow(prepAsset)];
            dispatch(setNewFixedAssetRecord(prepObj));
            dispatch(setNewFixedAssetRecordAutomatedData({}));
        }
    }, [newFixedAssetRecordAutomatedData])

    useEffect(() => {
        if (newFixedAssetRecord.documentType) {
            loadFixedAssetsListData(null, setFixedAssetsList);
        }
    }, [newFixedAssetRecord.documentType, newFixedAssetRecord.installation]);

    const handleOnChange = (e, type, name, updateRedux = true) => {
        if (!saveNewFixedAssetRecord) dispatch(setSaveNewFixedAssetRecord(true));

        let prepChange = {};

        if (name === "documentType") {
            if (isEmpty(toChangeDocumentType) && e.value !== newFixedAssetRecord.documentType && !isEmpty(newFixedAssetRecord.documentType)) {
                setToChangeDocumentType(e.value);
                return;
            }
        }

        if (type === "dd") {
            prepChange[name] = e.value;
        } else if (type === "input") {
            prepChange[name] = e.target.value;
        } else if (type === "datebox") {
            if (moment(e).isValid()) {
                prepChange[name] = moment(e).hour(10);
            } else {
                prepChange[name] = "";
            }
        }

        if (name === "documentType") {
            prepChange["documentTypeName"] = e.label;
            const advDoc = advancedTypes.find((el) => el._id === e.value);
            if (advDoc) {
                const preSelectedDocNumbering = advDoc?.documentNumbering?.find((el) => el.selected === "true");
                if (preSelectedDocNumbering) {
                    prepChange["preNumber"] = preSelectedDocNumbering.preNumber;
                    prepChange["number"] = +(preSelectedDocNumbering?.number || 0) + 1;
                }
            }
            if (!fromSale) {
                prepChange = {...defaultNewFixedAssetRecord, ...prepChange};
                delete prepChange.date;
                delete prepChange.dateTo;
            }
            setToChangeDocumentType("");
        } else if (name === "preNumber") {
            prepChange["number"] = +(preNumberGreekOptions.find((el) => el.value === e.value)?.number || 0) + 1;
        }

        if (updateRedux) {
            dispatch(setNewFixedAssetRecord({...newFixedAssetRecord, ...prepChange}));
        } else {
            return {...newFixedAssetRecord, ...prepChange};
        }
    }

    const tableFunctions = {
        insert: (e, data) => {
            if (e.key === "Enter") return;
            if (!saveNewFixedAssetRecord) dispatch(setSaveNewFixedAssetRecord(true));

            if (data.field === "name") {
                const alreadyExisting = newFixedAssetRecord.fixedAssets.some((el) => el._id === e.row._id);
                if (alreadyExisting) {
                    setIncrKey(incrKey + 1);
                    return toast.error("Το πάγιο αυτό έχει ήδη επιλεχθεί.");
                }
                const cloneFixedAssets = structuredClone(newFixedAssetRecord.fixedAssets);
                const md = e.row?.mydata;

                let prepObj = {
                    _id: e.row._id,
                    no: String(cloneFixedAssets.length + 1),
                    name: e.row.name,
                    mixedCode: e.row.systemCode + (e.row.manualCode ? ` / ${e.row.manualCode}` : ""),
                    acquisitionCost: getAcquisitionCost(e.row),
                    accumulatedDepreciation: e.row.accumulatedDepreciation,
                    amount: getDevaluation(e.row, moment(newFixedAssetRecord.dateTo).toDate(), calculationBy).devaluationAfterBalance,
                    balance: 0,
                    classificationCategory: md ? md[0].category : "",
                    classificationType: md ? md[0].type : "",
                }
                prepObj = correctFixedAssetRecordRow(prepObj);
                cloneFixedAssets.push(prepObj);

                dispatch(setNewFixedAssetRecord({...newFixedAssetRecord, fixedAssets: cloneFixedAssets}));
            }
        },
        update: (data, id, rowIndex, e) => {
            if (e.key === "Enter") return;
            if (!saveNewFixedAssetRecord) dispatch(setSaveNewFixedAssetRecord(true));

            const cloneFixedAssets = structuredClone(newFixedAssetRecord.fixedAssets);
            const findMatching = cloneFixedAssets[rowIndex];
            if (e?.row) { // Its advanced combo box
                const alreadyExisting = newFixedAssetRecord.fixedAssets.some((el, idx) => el._id === e.row._id && rowIndex !== idx);
                if (alreadyExisting) {
                    setIncrKey(incrKey + 1);
                    return toast.error("Το πάγιο αυτό έχει ήδη επιλεχθεί.");
                }
                findMatching._id = e.row._id;
                findMatching.name = e.row.name;
                findMatching.mixedCode = e.row.systemCode + (e.row.manualCode ? ` / ${e.row.manualCode}` : "");
                findMatching.acquisitionCost = getAcquisitionCost(e.row);
                findMatching.accumulatedDepreciation = e.row.accumulatedDepreciation;
                findMatching.amount = getDevaluation(e.row, moment(newFixedAssetRecord.dateTo).toDate(), calculationBy).devaluationAfterBalance;
                findMatching.balance = +Number(findMatching.acquisitionCost - findMatching.accumulatedDepreciation - findMatching.amount).toFixed(2);
                const md = findMatching?.mydata;
                if (md) {
                    findMatching.classificationCategory = md[0].category;
                    findMatching.classificationType = md[0].type;
                }
            } else {
                if (!isEmpty(data.amount)) {
                    findMatching.amount = +Number(data.amount).toFixed(2);
                    findMatching.balance = +Number(findMatching.acquisitionCost - findMatching.accumulatedDepreciation - findMatching.amount).toFixed(2);
                }
            }
            dispatch(setNewFixedAssetRecord({
                ...newFixedAssetRecord,
                fixedAssets: cloneFixedAssets,
            }));
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            if (!saveNewFixedAssetRecord) dispatch(setSaveNewFixedAssetRecord(true));

            const cloneFixedAssets = structuredClone(newFixedAssetRecord.fixedAssets);
            cloneFixedAssets.splice(rowIndex, 1);
            cloneFixedAssets.forEach((row, idx) => {
                row.no = String(idx + 1);
            })
            dispatch(setNewFixedAssetRecord({
                ...newFixedAssetRecord,
                fixedAssets: cloneFixedAssets,
            }))
        },
    }

    const handleLoadAll = () => {
        setLoadingAll(true);
        axios.get(`${process.env.REACT_APP_API_URL2}/fixedassets/fetch-active-assets`, {
            params: {
                company: company.id,
                documentId: newFixedAssetRecord.documentType,
                category: fillAssetCategory,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                const assets = res.data.data;
                if (assets.length > 0) {
                    let newTable = structuredClone(newFixedAssetRecord.fixedAssets);
                    for (const asset of assets) {
                        if ((+asset.balance / (+asset.quantity || 1)) <= 0.03 && (!asset?.additionalImprovements || asset?.additionalImprovements?.length === 0)) continue;

                        const md = asset?.mydata;
                        let prepObj = {
                            _id: asset._id,
                            no: String(newTable.length + 1),
                            name: asset.name,
                            mixedCode: asset.systemCode + (asset.manualCode ? ` / ${asset.manualCode}` : ""),
                            acquisitionCost: getAcquisitionCost(asset),
                            accumulatedDepreciation: asset.accumulatedDepreciation,
                            amount: getDevaluation(asset, moment(newFixedAssetRecord.dateTo).toDate(), calculationBy).devaluationAfterBalance,
                            classificationCategory: md ? md[0]?.category || "" : "",
                            classificationType: md ? md[0]?.type || "" : "",
                        }
                        prepObj = correctFixedAssetRecordRow(prepObj);
                        if (prepObj.amount > 0) {
                            newTable = newTable.filter((el) => el._id !== asset._id);
                            newTable.push(prepObj);
                        }
                        newTable.forEach((row, idx) => {
                            row.no = String(idx + 1);
                        })
                    }
                    dispatch(setNewFixedAssetRecord({
                        ...newFixedAssetRecord,
                        fixedAssets: newTable
                    }));
                    toast.success("Επιτυχής συμπλήρωση αναπόσβεστων παγίων στον πίνακα.", {autoClose: 2000});
                } else {
                    toast.info("Δεν βρέθηκε αναπόσβεστο πάγιο προς συμπλήρωση στον πίνακα παγίων.", {autoClose: 2000});
                }
            } else {
                toast.error(res.data.message);
            }
            setLoadingAll(false);
        }).catch((err) => {
            setLoadingAll(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const disabledFields = isEmpty(newFixedAssetRecord.documentType);

    return (
        <div className="product-form position-relative">
            {disabledFields && <div className="overlay_w">Παρακαλώ επιλέξτε τύπο παραστατικού</div>}
            <Row>
                <Col md={3} className={"showWithOverlay"}>
                    <Dropdown
                        name={"documentType"}
                        label={"Τύπος Παραστατικού"}
                        key={newFixedAssetRecord.documentType}
                        defaultValue={documentTypesOptions.find((el) => el.value === newFixedAssetRecord.documentType)}
                        required={true}
                        options={documentTypesOptions}
                        onChange={(e) => handleOnChange(e, "dd", "documentType")}
                    />
                </Col>
            </Row>
            <Row className={"mt-2"}>
                <Col md={3}>
                    <Dropdown
                        name={"installation"}
                        label={"Εγκατάσταση"}
                        key={newFixedAssetRecord.installation}
                        defaultValue={installationOptions.find((el) => el.value === newFixedAssetRecord.installation)}
                        required={true}
                        options={installationOptions}
                        onChange={(e) => handleOnChange(e, "dd", "installation")}
                    />
                </Col>
                <Col md={2}>
                    <DateBox
                        label={"Ημερομηνία εγγραφής"}
                        name={"date"}
                        required={true}
                        selected={moment(newFixedAssetRecord.date).isValid() ? moment(newFixedAssetRecord.date).toDate() : null}
                        onChange={(e) => handleOnChange(e, "datebox", "date")}
                    />
                </Col>
                <Col md={2}>
                    <DateBox
                        label={"Απόσβεση έως"}
                        name={"dateTo"}
                        required={true}
                        selected={moment(newFixedAssetRecord.dateTo).isValid() ? moment(newFixedAssetRecord.dateTo).toDate() : null}
                        onChange={(e) => handleOnChange(e, "datebox", "dateTo")}
                    />
                </Col>
                <Col md={2}>
                    <Dropdown
                        label={"Σειρά"}
                        name="preNumber"
                        key={newFixedAssetRecord.preNumber}
                        defaultValue={preNumberGreekOptions.find((el) => el.value === newFixedAssetRecord.preNumber)}
                        options={preNumberGreekOptions}
                        required={true}
                        onChange={(e) => handleOnChange(e, "dd", "preNumber")}
                    />
                </Col>
                <Col md={2}>
                    <Input
                        label={"Αρίθμηση"}
                        charLimit={10}
                        name="number"
                        value={newFixedAssetRecord.number}
                        disabled={true}
                    />
                </Col>
            </Row>
            <Row className={"mt-2"}>
                <Col md={12}>
                    <Input
                        name={"reason"}
                        label={"Αιτιολογία"}
                        value={newFixedAssetRecord.reason}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "reason")}
                    />
                </Col>
            </Row>
            {!fromSale && (
                <Row className={"mt-3"}>
                    <div className={"text-muted"}><i>Αυτόματη συμπλήρωση παγίων</i></div>
                    <Col md={3}>
                        <Dropdown
                            name={"fillAssetCategory"}
                            options={fixedAssetsCategoryOptions}
                            key={fillAssetCategory}
                            defaultValue={fixedAssetsCategoryOptions.find((el) => el.value === fillAssetCategory)}
                            label={"Κατηγορία παγίων προς αυτόματη συμπλήρωση"}
                            onChange={(e) => setFillAssetCategory(e.value)}
                        />
                    </Col>
                    <Col md={3}>
                        <Button size={"sm"} onClick={() => handleLoadAll()} style={{marginTop: "28px"}} loading={loadingAll}>Αυτόματη συμπλήρωση</Button>
                    </Col>
                </Row>
            )}
            <Row className={"mt-2"}>
                <Col md={12}>
                    <div className={"text-muted"}><i>Πίνακας παγίων</i></div>
                    <EditableTable
                        tableName={"Fixed Asset Record Assets"}
                        key={"Fixed Asset Record Assets" + incrKey}
                        allowActions={true}
                        actionButtons={{
                            print: false,
                            delete: true,
                            export: false,
                            edit: true,
                        }}
                        onUpdate={tableFunctions}
                        allowInsertRow={true}
                        columns={tableColumns}
                        enableNewRowCheckbox={true}
                        data={newFixedAssetRecord.fixedAssets}
                    />

                </Col>
            </Row>
            <Row className={"mt-2"}>
                <Col md={12}>
                    <TextArea
                        rows={"4"}
                        label={"Σημειώσεις"}
                        name={"notes"}
                        limit={"1000"}
                        value={newFixedAssetRecord.notes}
                        onChange={(e) => handleOnChange(e, "input", "notes")}
                    />
                </Col>
            </Row>

            <Modal show={!isEmpty(toChangeDocumentType)} onHide={() => setToChangeDocumentType("")} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>Αλλαγή τύπου παραστικού</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Είσαστε σίγουροι ότι θέλετε να αλλάξετε τύπο γενικού παραστατικού; Όλα τα δεδομένα που έχετε συμπληρώσει θα χαθούν.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setToChangeDocumentType("")}>
                        Ακύρωση
                    </Button>
                    <Button variant="primary" onClick={() => {
                        handleOnChange(documentTypesOptions.find((el) => el.value === toChangeDocumentType), "dd", "documentType")
                    }}>
                        Αλλαγή
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default NewFixedAssetRecord;
